<template>
	<div>
		<div class="modal fade" id="subEdit" data-backdrop="static">
			<div class="modal-dialog" role="document">
				<!--
				=================================================================================================================
													  MAIN/EXAM CREATION MODAL!
				=================================================================================================================
			-->

				<div
					style="width: 60%; margin: 0 auto"
					class="modal-content"
					v-if="
						!this.data.creationCPF &&
						!this.data.creationShip &&
						!this.data.creationPassaport &&
						!this.data.creationType
					"
				>
					<div class="modal-header">
						<button
							type="button"
							class="close"
							data-dismiss="modal"
							aria-label="Close"
						>
							<span aria-hidden="true">&times;</span>
						</button>
						<h4 class="modal-title" id="myModalLabel">
							EDITAR VACINA
						</h4>
					</div>
					<div class="modal-body">
						<div class="col-sm-3">
							<span>Marca da Vacina</span>
							<select
								style="text-transform: uppercase"
								v-model="data.marca"
								class="form-control"
							>
								<option
									v-for="(lab, index) in laboratory"
									:key="index"
									:value="lab"
								>
									{{ lab }}
								</option>
							</select>
						</div>

						<div class="col-sm-3">
							<span>DATA</span>
							<input
								class="form-control"
								type="date"
								v-model="data.data_vacina"
								v-on:change="
									handleChangeDataFormat(
										$event,
										'data_vacina'
									)
								"
								id="dataImpressa"
							/>
						</div>

						<div class="col-sm-3">
							<span>VENC. VACINA</span>

							<input
								class="form-control"
								type="date"
								v-model="data.vencimento_vacina"
								v-on:change="
									handleChangeDataFormat(
										$event,
										'vencimento_vacina'
									)
								"
								id="vencimento"
							/>
						</div>

						<div class="col-sm-3">
							<span>TIPO DE VACINA</span>

							<div class="add-more-section">
								<select
									v-model="data.tipo_vacina"
									class="form-control"
								>
									<option
										v-for="(teste, index) in tipo_vacina"
										:key="index"
										:value="teste.nome_tipo_vacina"
										:id="teste.nome_tipo_vacina"
									>
										{{ teste.nome_tipo_vacina }}
									</option>
								</select>
							</div>
						</div>
						<!--
            <div class="col-sm-6">
              <span>STATUS DA VACINA</span>

              <div class="add-more-section">
                <div class="form-control">
                  {{data.status_vacina}}%
                </div>
              </div>
            </div> -->

						<div class="clearfix"></div>
						<br />
						<!-- <pre>{{data}}</pre> -->
					</div>
					<div class="modal-footer">
						<div class="modal-footer__buttons">
							<button
								type="button"
								class="btn btn-default"
								data-dismiss="modal"
							>
								<i class="fa fa-close"></i> Cancelar
							</button>
							<div>
								<label
									class="form-control--no-padding"
									for="inputUpdateImagemVacina"
								>
									<div class="btn-upload-image">
										Anexar imagem
										<i class="fa fa-upload"></i>
									</div>
									<!-- v-model="data.anexo" -->
									<div class="file">
										<input
											type="file"
											multiple="false"
											class="inputUpdateImagemVacina"
											accept=".jpg, .png, .jpeg, .gif, .bmp, .tif, .svg, .pdf, .tiff|image/*"
											v-on:change="
												handleUploadImage($event)
											"
											id="inputUpdateImagemVacina"
										/>
									</div>
								</label>
								<aBtn
									action="private-save-vacinas"
									@click="save"
									text="Salvar"
									icon="save"
									type="primary"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	/*

id precisa existir para poder ocorrer a criação

*/
	import clone from 'js/clone';
	import aBox from 'box';
	import aBtn from 'btn';
	import WBS from 'js/http';
	import toastr from 'toastr';
	import axios from 'axios';
	import moment from 'moment';
	import { mask } from 'vue-the-mask';
	// md-autocomplete MdAutocomplete
	import { MdAutocomplete } from 'vue-material/dist/components';

	let reset = {
		empresa: '',
		nome_vacina: '',
		colaborador: '',
		cargo: '',
		navio: '',
		frota: '',
		idade: 0,

		status: '',

		statusMask: "'##%'",

		data_vacina: ``,
		dataEnviada: `${new Date().getFullYear()}-${
			new Date().getMonth() + 1 < 10 && 0
		}${new Date().getMonth() + 1}-${new Date().getDate()}T${
			new Date().getHours() < 10 ? 0 : ''
		}${new Date().getHours()}:${
			new Date().getMinutes() <= 10 ? 0 : ''
		}${new Date().getMinutes()}`,
		vencimento_vacina: ``,
		validade: '',
		marca: '',
		creationCPF: false,
		creationShip: false,
		creationType: false,
		creationPassaport: false,
		municipio: '',
		estado: '',
		RG: '',
		CPF: '',
		passaport: '',
		control: '',
		tipo_vacina: '',
	};

	export default {
		name: 'modalEditarVaciona',
		components: { aBox, aBtn, mask },
		data() {
			return {
				data: {
					moment: moment,
					...clone(reset),
				},
				test: null,
				pessoas: [],

				cargos: [
					{
						navio: 'Não há dados',
					},
				],

				estados: null,
				municipios: null,
				tipo_vacina: [
					{
						nome_tipo_vacina: 'Não há dados!',
					},
				],

				laboratory: ['Astrazeneca', 'Coronavac', 'Janssen', 'Pfizer'],
			};
		},
		methods: {
			handleUploadImage(e) {
				const file = e.target.files[0];
				const fileName = file.name.replace(/ /g, '');
				var blob = file.slice(0, file.size, file.type);
				const updatedFile = new File([blob], fileName, {
					type: file.type,
				});
				this.uploadImage(updatedFile);
			},

			async uploadImage(file) {
				const backendUrl = 'http://viamed.ddns.net:3000';

				const formData = new FormData();
				formData.append('file', file);

				const uploadedImageUrl = await axios
					.post(`${backendUrl}/upload`, formData, {
						headers: {
							Accept: 'application/json',
							'Content-Type': 'multipart/form-data',
							'Access-Control-Allow-Origin': '*',
						},
					})
					.then(() => `${backendUrl}/uploads/${file.name}`);
				this.data.anexo = uploadedImageUrl;
			},

			handleParseDateTimeToString(dateTimeValue) {
				return moment(dateTimeValue).format('DD/MM/YYYY');
			},

			handleChangeDataFormat(e, dateModel) {
				const stringValue = e.target.value;
				const dateStringParsed =
					moment(stringValue).format('YYYY-MM-DD');
				this.data[dateModel] = dateStringParsed;
			},

			handleChangeCPF() {
				const cpf = String(this.data.CPF).replace(/[^\w\s]/gi, '');

				if (cpf.length < 9) return;

				const testParms = {
					pager: {
						page: '0',
						qnt: '999',
					},
					filter: `cpf=${cpf}`,
				};

				WBS.send('private-read-pessoas', testParms, (resp) => {
					if (!resp.data.table[0]) {
						return toastr.error('CPF não cadastrado');
						// toastr.error(resp.msgs[0])
					}

					const tableValues = resp.data.table[0];

					this.data.empresa = tableValues.empresa;
					this.data.nome = tableValues.nome; //colaborador
					this.data.RG = tableValues.RG;
					this.data.cargo = tableValues.cargo;
				});
			},

			handleLoadTiposDeVacinas() {
				const testParms = {
					pager: {
						page: '0',
						qnt: '9999',
					},
				};

				WBS.send('private-read-tipos_de_vacina', testParms, (resp) => {
					const unorderedTipoVacina = resp.data.table;
					this.tipo_vacina = unorderedTipoVacina.sort((a, b) =>
						a.nome_tipo_vacina.localeCompare(b.tipo_vacina)
					); //order the object alphabetically

					const lastTipoDeVacina =
						this.tipo_vacina[this.tipo_vacina.length - 1];

					this.data.tipo_vacina = lastTipoDeVacina.tipo_vacina;
				});
			},

			handleChangePassaport() {
				const passaport = String(this.data.passaport).replace(
					/[^\w\s]/gi,
					''
				);
				// const passaport = this.data.passaport
				if (passaport.length < 2) return;

				const testParms = {
					pager: {
						page: '0',
						qnt: '999',
					},
					filter: `passaport=${passaport}`,
				};

				WBS.send('private-read-passaport', testParms, (resp) => {
					if (!resp.data.table[0]) {
						return toastr.error('Passaporte não cadastrado');
						// toastr.error(resp.msgs[0])
					}

					const tableValues = resp.data.table[0];

					this.data.empresa = tableValues.empresa;
					this.data.nome = tableValues.nome; //colaborador
					this.data.RG = tableValues.RG;
					this.data.cargo = tableValues.cargo;
				});
			},

			handleToggleCreationCPF() {
				this.data.creationCPF = !this.data.creationCPF;
			},

			handleToggleCreationShip() {
				this.data.creationShip = !this.data.creationShip;
			},

			handleToggleCreationType() {
				this.data.creationType = !this.data.creationType;
			},

			handleToggleCreationPassaport() {
				this.data.creationPassaport = !this.data.creationPassaport;
			},

			async open(data = null) {
				if (data != null) {
					await WBS.send(
						'private-custom-vacinasFind',
						data,
						(resp) => {
							if (resp.status == 'success') {
								this.data = resp.data;
								this.loading = false;
								this.data.vencimento_vacina = moment(
									resp.data.vencimento_vacina
								).format('YYYY-MM-DD');
								this.data.data_vacina = moment(
									resp.data.data_vacina
								).format('YYYY-MM-DD');
							} else {
								toastr.error(resp.msgs[0]);
							}
						}
					);
				} else this.data = clone(reset);
				$('#subEdit').modal('show');
			},

			save() {
				this.data.CPF = String(this.data.CPF).replace(/[^\w\s]/gi, '');

				this.data.control = `${this.data.CPF} ${this.data.data}`;
				this.data.data_vacina = moment(this.data.data_vacina).format(
					'YYYY-MM-DD'
				);
				this.data.vencimento_vacina = moment(
					this.data.vencimento_vacina
				).format('YYYY-MM-DD');

				WBS.send('private-save-vacinas', this.data, (resp) => {
					if (resp.status == 'success') {
						toastr.success('Registro alterado com sucesso!');
						this.$emit('update');
						$('#subEdit').modal('hide');
					} else {
						toastr.error(resp.msgs[0]);
					}
				});
			},

			saveCpf() {
				this.data.CPF = String(this.data.CPF).replace(/[^\w\s]/gi, '');

				WBS.send('private-save-pessoas', this.data, (resp) => {
					if (resp.status == 'success') {
						toastr.success('Registro alterado com sucesso!');
						this.handleToggleCreationCPF();
						// $('#subEdit').modal('hide')
					} else {
						toastr.error(resp.msgs[0]);
						// console.log(resp)
						// console.log(this.data)
					}
				});

				// console.log("submit ----------*-------------")
			},

			handleLoadNavios() {
				const testParms = {
					pager: {
						page: '0',
						qnt: '9999',
					},
				};

				WBS.send('private-read-navios', testParms, (resp) => {
					const unorderednavios = resp.data.table;
					this.navios = unorderednavios.sort((a, b) =>
						a.navio.localeCompare(b.navio)
					); //order the object alphabetically

					if (this.navios.length - 1 > 0) {
						const lastNavio = this.navios[this.navios.length - 1];
						this.data.navio = lastNavio.navio;
					}
				});
			},

			handleLoadCargos() {
				const testParms = {
					pager: {
						page: '0',
						qnt: '9999',
					},
				};

				WBS.send('private-read-cargos', testParms, (resp) => {
					const unorderedCargos = resp.data.table;
					this.cargos = unorderedCargos.sort((a, b) =>
						a.nome_cargo.localeCompare(b.nome_cargo)
					); //order the object alphabetically

					// console.log(this.cargos)
				});
			},

			handleLoadLocalDeExames() {
				const testParms = {
					pager: {
						page: '0',
						qnt: '9999',
					},
				};

				WBS.send('private-read-local_de_exame', testParms, (resp) => {
					const unorderedLocalDoteste = resp.data.table;
					this.localDoteste = unorderedLocalDoteste.sort((a, b) =>
						a.nome_local_exame.localeCompare(b.nome_local_exame)
					); //order the object alphabetically
				});
			},

			handleLoadEmpresas() {
				const testParms = {
					pager: {
						page: '0',
						qnt: '9999',
					},
					filter: `regiao='OFF'`,
				};

				WBS.send('private-read-customers', testParms, (resp) => {
					const unorderedEmpresas = resp.data.table;
					this.empresas = unorderedEmpresas.sort((a, b) =>
						a.razao_social.localeCompare(b.razao_social)
					); //order the object alphabetically
				});
			},

			savePassaport() {
				WBS.send('private-save-passaport', this.data, (resp) => {
					if (resp.status == 'success') {
						toastr.success('Registro alterado com sucesso!');
						this.handleToggleCreationPassaport();
					} else {
						toastr.error(resp.msgs[0]);
						// console.log(resp)
						// console.log(this.data)
					}
				});
			},

			saveType() {
				WBS.send('private-save-tipos_de_exame', this.data, (resp) => {
					if (resp.status == 'success') {
						toastr.success('Registro alterado com sucesso!');
						this.handleToggleCreationType();
						this.handleLoadTiposDeExames();
					} else {
						toastr.error(resp.msgs[0]);
						// console.log(resp)
						// console.log(this.data)
					}
				});
			},

			onSelectLocalDeColeta(e) {
				let index = e.target.selectedIndex;

				// console.log()

				/*
        id: 1
        estado: "AP"
        municipio: "Amapá"
        nome_local_exame: "NOME"
      */

				// console.log(
				//   this.localDoteste[index]
				// )

				let selectedLocal = this.localDoteste[index];

				// console.log("==selectedLocal==")
				// console.log(selectedLocal)

				// console.log("nvsdjnvsjnvjsdnvsdjk")

				this.data.estado = selectedLocal.estado.toUpperCase();
				this.data.municipio = selectedLocal.municipio;
				this.data.nome_local_exame = selectedLocal.nome_local_exame;
			},

			onSelectState() {
				axios
					.get(
						`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${this.data.estado}/municipios?orderBy=nome`
					)
					.then((response) => (this.municipios = response.data));
			},
		},

		mounted() {
			this.handleLoadTiposDeVacinas();
		},
	};
</script>

<style>
	span {
		text-transform: uppercase;
	}

	.modal-dialog {
		width: 80% !important;
	}

	.modal-footer__buttons {
		display: flex;
		justify-content: space-between;
	}

	.add-more-section {
		display: flex;
	}

	/*
.table{
	overflow
}
*/

	.md-autocomplete + strong {
		margin-top: 36px;
		display: block;
	}

	.md-autocomplete-items {
		z-index: 99 !important;
		background: white !important;
		position: relative !important;
		top: 85% !important;
	}

	.md-menu-content {
		min-width: 33% !important;
		background: white !important;
		/*
	top: 430px !important;
	*/
		z-index: 99999 !important;
	}

	.md-list {
		width: 100% !important;
		background: white;
		top: 430px !important;
		z-index: 99999;
	}

	.col--featured {
		/*
	*/
		height: 54px !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/cadastros/vacinas/modalSubEdit.vue